import posthog from 'posthog-js';

export function getCookie(cname: string) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function deleteCookie(name: string) {
  setCookie(name, '', -1);
}

export function setCookie(
  name: string,
  value: string | undefined | null,
  expiryDays = 5,
) {
  // Previously, we set the domain with a dot when writing cookies.  Remove any of those
  // before adding our new cookie:
  document.cookie = [
    `${name}=`,
    `path=/`,
    `domain=.${window.location.hostname}`,
    'expires=Thu, 01 Jan 1970 00:00:01 GMT',
  ].join('; ');

  const date = new Date();
  date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  document.cookie = [
    `${name}=${value || ''}`,
    `expires=${date.toUTCString()}`,
    `path=/`,
  ].join('; ');
}

export function getUserJwt() {
  const value =
    emptyToUndefined(localStorage['memberstack_jwt_if_cookies_do_not_work']) ||
    emptyToUndefined(getCookie('test_jwt')) ||
    emptyToUndefined(getCookie('memberstack_jwt'));
  if (value && !value.startsWith('rl-auth-')) {
    console.warn('Ignoring invalid jwt (probably from memberstack):', value);
    return undefined;
  }
  return value;
}

export function getUserId() {
  return getCookie('memberstack_id');
}

export function saveUserJwt(jwt: string) {
  setCookie('memberstack_jwt', jwt, 365);
  delete localStorage['memberstack_jwt_if_cookies_do_not_work'];
  if (getCookie('memberstack_jwt') !== jwt) {
    // Ephiphany (aka. GNOME Web aka. Safari for Linux) doesn't store cookies for localhost.
    console.warn('This browser does not let us set cookies.  I hate it.');
    localStorage['memberstack_jwt_if_cookies_do_not_work'] = jwt;
  }
}

export function logOutWithoutReload() {
  deleteCookie('token'); // where is this set from?
  deleteCookie('memberstack_jwt');
  deleteCookie('memberstack_id');
  deleteCookie('__ms');
  deleteCookie('ms-data');
  posthog.reset();
  delete localStorage['memberstack_jwt_if_cookies_do_not_work'];
}

export function saveUserId(id: string) {
  setCookie('memberstack_id', id);
}

export function saveDeviceId(deviceId: string) {
  setCookie('sabil-device-id', deviceId);
}

export function getDeviceId() {
  return getCookie('sabil-device-id');
}

export function saveBetaStatus(betaStatus: string) {
  setCookie('betaStatus', betaStatus);
}

function emptyToUndefined(v: string | undefined | null) {
  if (!v) return undefined;
  if (v.trim().length === 0) return undefined;
  return v;
}
